import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { Icon } from '../../components/shared';

const WidgetNotPaidFor = () => {
  const { t } = useTranslation();

  // Note: This component doesn't have access to WidgetContext, so it uses default colors
  // If needed, we could pass primaryColor as a prop
  const primary = 'var(--feel-primary)';
  const secondary = colors.cabaret;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: colors.carouselPink }}>
              <Icon name="info" size="xl" color={colors.white} />
            </div>
          </div>

          {/* Title */}
          <h3 className="text-xl font-semibold mb-4" style={{ color: colors.mineShaft }}>
            {t('GENERAL.providerHasNotPaid')}
          </h3>

          {/* Description */}
          <p className="text-gray-600 leading-relaxed">
            {t(
              'WIDGET.notPaidDescription',
              'This provider has not yet activated their subscription. Please check back later or contact the provider for more information.'
            )}
          </p>

          {/* Action Button */}
          <div className="mt-8">
            <button
              style={{
                backgroundColor: primary,
              }}
              className="inline-flex items-center px-6 py-3 text-white font-medium rounded-lg transition-all duration-200 hover:scale-105 shadow-lg"
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = secondary;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = primary;
              }}
              onClick={() => window.location.reload()}
            >
              <Icon name="refresh" size="sm" className="mr-2" />
              {t('GENERAL.refresh', 'Refresh')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetNotPaidFor;
